import script from "./UiSpinner.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiSpinner.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiSpinner.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./UiSpinner.vue.scss?vue&type=style&index=0&id=7bf2fcbb&lang=scss&module=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiSpinner.vue?vue&type=style&index=0&id=7bf2fcbb&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__